"use client";

import { URL } from "@constants/path";
import { DOMAINE_NAME, IS_DEV } from "@constants/env";
import Link from "next/link";
import { useEffect, useState } from "react";
import * as Icon from "react-bootstrap-icons";

export default function Footer1({ pagesFooter }) {
  const [description, setDescription] = useState();
  const [pages, setPages] = useState(pagesFooter || []);

  function getCurrentPath(id) {
    const currentPage = pages.find((item) => item.id === id);
    return {
      link: currentPage?.seo_permalink,
      title: currentPage?.title,
    };
  }

  function setPath(id) {
    const firstPath = getCurrentPath(64).link;
    const secondPath = getCurrentPath(id).link;

    if (id == 64) {
      return "/" + firstPath ?? "#";
    } else {
      if (firstPath && secondPath) {
        return "/" + firstPath + "/" + secondPath;
      }
      return "/#";
    }

  }

  useEffect(() => {
    fetch(IS_DEV ? URL.FOOTER_TEXT.replace(DOMAINE_NAME, "/admin-api") : URL.FOOTER_TEXT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        is_api: 1,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setDescription(res[0].text);
      })
      .catch(() => {});

  }, []);

  return (
    <>
      <footer className="bottom pt-12">
        <div className="container">
          <div className="grid xl:grid-cols-6 md:grid-cols-6 sm:grid-cols-1 gap-7 pb-12">
            <div className="col-span-2">
              <div className="bottom-logo xl:max-w-sm md:w-full">
                <Link href="/">
                  <img
                    width={134}
                    height={29}
                    sizes="50vw"
                    src="/images/vieillir-a-la-maison-logo.svg"
                    alt="Vieillir à la maison, aide, soins à domicile"
                  />
                </Link>
                <div className="footer-text mt-2">
                  <div dangerouslySetInnerHTML={{ __html: description }} />
                </div>
              </div>
            </div>

            <div className="bottom-widget">
              <h4 className="mb-3 text-pgray-800 font-semibold">
                Aide à domicile
              </h4>
              <ul className="line-height-custom-1">
                <li className=" text-pgray-500 leading-8 text-base">
                  <Link
                    href={setPath(64)}
                    className="hover:text-primary-1000 transition duration-150"
                  >
                    {getCurrentPath(64).title}
                  </Link>
                </li>
                <li className=" text-pgray-500 leading-8 text-base">
                  <Link
                    href={setPath(67)}
                    className="hover:text-primary-1000 transition duration-150"
                  >
                    {getCurrentPath(67).title}
                  </Link>
                </li>
                <li className=" text-pgray-500 leading-8 text-base">
                  <Link
                    href={setPath(69)}
                    className="hover:text-primary-1000 transition duration-150"
                  >
                    {getCurrentPath(69).title}
                  </Link>
                </li>
                <li className=" text-pgray-500 leading-8 text-base">
                  <Link
                    href={setPath(70)}
                    className="hover:text-primary-1000 transition duration-150"
                  >
                    {getCurrentPath(70).title}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="bottom-widget">
              <h4 className="mb-3 text-pgray-800 font-semibold">
                Milieu de vie
              </h4>
              <ul className="line-height-custom-1">
                <li className=" text-pgray-500 leading-8 text-base">
                  <Link
                    href="#"
                    className="hover:text-primary-1000 transition duration-150"
                  >
                    Trouver un milieu de vie
                  </Link>
                </li>
                <li className=" text-pgray-500 leading-8 text-base">
                  <Link
                    href="#"
                    className="hover:text-primary-1000 transition duration-150"
                  >
                    Appartement 50 ans et +
                  </Link>
                </li>
                <li className=" text-pgray-500 leading-8 text-base">
                  <Link
                    href="#"
                    className="hover:text-primary-1000 transition duration-150"
                  >
                    Résidences privées (RPA)
                  </Link>
                </li>
                <li className=" text-pgray-500 leading-8 text-base">
                  <Link
                    href="#"
                    className="hover:text-primary-1000 transition duration-150"
                  >
                    CHSLD privés
                  </Link>
                </li>
              </ul>
            </div>
            <div className="bottom-widget">
              <h4 className="mb-3 text-pgray-800 font-semibold">Emplois</h4>
              <ul className="line-height-custom-1">
                <li className=" text-pgray-500 leading-8 text-base">
                  <Link
                    href="#"
                    className="hover:text-primary-1000 transition duration-150"
                  >
                    Voir tous les emplois
                  </Link>
                </li>
                <li className=" text-pgray-500 leading-8 text-base">
                  <Link
                    href="#"
                    className="hover:text-primary-1000 transition duration-150"
                  >
                    Envoyer votre candidature
                  </Link>
                </li>
                <li className=" text-pgray-500 leading-8 text-base">
                  <Link
                    href="#"
                    className="hover:text-primary-1000 transition duration-150"
                  >
                    Publier une offre d&apos;emploi
                  </Link>
                </li>
              </ul>
            </div>
            <div className="bottom-widget">
              <h4 className="mb-3 text-pgray-800 font-semibold">À propos</h4>
              <ul className="line-height-custom-1">
                <li className=" text-pgray-500 leading-8 text-base">
                  <Link
                    href={"/" + getCurrentPath(61).link ?? "#"}
                    className="hover:text-primary-1000 transition duration-150"
                  >
                    {getCurrentPath(61).title}
                  </Link>
                </li>
                <li className=" text-pgray-500 leading-8 text-base">
                  <Link
                    href={"/" + getCurrentPath(66).link ?? "#"}
                    className="hover:text-primary-1000 transition duration-150"
                  >
                    {getCurrentPath(66).title}
                  </Link>
                </li>
                <li className=" text-pgray-500 leading-8 text-base">
                  <Link
                    href={"/" + getCurrentPath(72).link ?? "#"}
                    className="hover:text-primary-1000 transition duration-150"
                  >
                    Offrez vos services
                  </Link>
                </li>
                <li className=" text-pgray-500 leading-8 text-base">
                  <Link
                    href={"/" + getCurrentPath(62).link ?? "#"}
                    className="hover:text-primary-1000 transition duration-150"
                  >
                    {getCurrentPath(62).title}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="py-12 border-t border-pgray-100">
            <div className="info-text-footer">
              <div className="text-pgray-400 text-sm">
                <p>
                  {new Date().getFullYear()} © Vieillir à la maison.{" "}
                  <Link
                    href="/politique-confidentialite-cookie"
                    className="text-black hover:text-primary-1000 transition duration-150"
                  >
                    Politique de confidentialité.
                  </Link>{" "}
                  Tous droits réservé.
                </p>
              </div>
              <div className="container-link-footer">
                <a 
                  href="https://whc.ca/heberge-au-quebec/?aff=3153&gbid=2fr" 
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(e.currentTarget.href, 'popupWindow', 'width=450, height=619, status=no, scrollbars=no, menubar=no');
                  }}
                >
                  <img src="https://s.whc.ca/badges/badge-heberge-quebec.svg" width="110" alt="Badge québécois" />
                </a>
                <a 
                  href="https://whc.ca/ecoresponsable/?aff=3153&gbid=1fr" 
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(e.currentTarget.href, 'popupWindow', 'width=450, height=610, status=no, scrollbars=no, menubar=no');
                  }}
                >
                  <img src="https://s.whc.ca/badges/green-badge-1-fr.svg" width="130" alt="Badge hébergement écoresponsable" />
                </a>
              </div>
              <div className="flex lg:justify-end items-center">
                <Link href="#" className="text-pgray-400 inline-block ml-4">
                  <Icon.Facebook />
                </Link>

                <Link href="#" className="text-pgray-400 inline-block ml-4">
                  <Icon.Twitter />
                </Link>

                <Link href="#" className="text-pgray-400 inline-block ml-4">
                  <Icon.Linkedin />
                </Link>

                <Link href="#" className="text-pgray-400 inline-block ml-4">
                  <Icon.Youtube />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
